export const equityInfoBasePath = '/companies/equity-information';

export * from './getEquityInfo';
export * from './putEquityInfo';
